import moment from "moment";

export const getDateRangeForPreset = (preset: string): { updatedFromDate?: string; updatedToDate?: string } => {
  const today = moment();
  switch (preset) {
    case "last3months":
      return {
        updatedFromDate: today.clone().subtract(3, "months").format("YYYY-MM-DD"),
        updatedToDate: today.format("YYYY-MM-DD"),
      };
    case "lastWeek":
      return {
        updatedFromDate: today.clone().subtract(1, "week").startOf("week").format("YYYY-MM-DD"),
        updatedToDate: today.clone().subtract(1, "week").endOf("week").format("YYYY-MM-DD"),
      };
    case "nextWeek":
      return {
        updatedFromDate: today.clone().add(1, "day").format("YYYY-MM-DD"),
        updatedToDate: today.clone().add(1, "week").format("YYYY-MM-DD"),
      };
    case "today":
      const todayStr = today.format("YYYY-MM-DD");
      return { updatedFromDate: todayStr, updatedToDate: todayStr };
    case "tomorrow":
      const tomorrow = today.clone().add(1, "day").format("YYYY-MM-DD");
      return { updatedFromDate: tomorrow, updatedToDate: tomorrow };
    case "nextWeek":
      const startOfNextWeek = today.clone().add(1, "week").startOf("week").format("YYYY-MM-DD");
      const endOfNextWeek = today.clone().add(1, "week").endOf("week").format("YYYY-MM-DD");

    case "all":
      return {};

    default:
      return {};
  }
};

function getPreviousWorkday(workday: moment.Moment): moment.Moment {
  let day = workday.day();
  let diff = 1; // returns yesterday
  if (day == 0 || day == 1) {
    // is Sunday or Monday
    diff = day + 2; // returns Friday
  }
  return workday.subtract(diff, "days");
}

export const getDateRangeForDate = (
  date: Date | string,
  fieldNames: string[],
): { updatedFromDate?: string; updatedToDate?: string } => {
  const a = getPreviousWorkday(moment(date)).format("YYYY-MM-DD");
  const b = moment(date).format("YYYY-MM-DD");
  return { [fieldNames[0]]: a, [fieldNames[1]]: b };
};
